// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { useContentSearchDataView } from "@store/Framework/Store/Data/ContentSearch/ContentSearchHooks";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/ProductList/Handlers/UpdateSearchFields";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { FC } from "react";

export interface ContentSearchResultsListPaginationPresentationProps
    extends ExpandStyles<ContentSearchResultsListPaginationStyles> {}

export interface ContentSearchResultsListPaginationProps extends ContentSearchResultsListPaginationPresentationProps {}

export interface ContentSearchResultsListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const contentSearchResultsListPaginationStyles: ContentSearchResultsListPaginationStyles = {};

const ContentSearchResultsListPagination: FC<ContentSearchResultsListPaginationProps> = ({
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(contentSearchResultsListPaginationStyles, extendedStyles, overridedStyles);
    const dispatch = useAppDispatch();
    const baseContentSearchDataView = useContentSearchDataView();
    const contentSearchDataView = usePersistentDataView(baseContentSearchDataView);

    if (!contentSearchDataView.value || !contentSearchDataView.pagination) {
        return null;
    }

    const pagination = contentSearchDataView.pagination;

    const changePage = (newPageIndex: number) => {
        dispatch(updateSearchFields({ cpage: newPageIndex }));
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        dispatch(updateSearchFields({ cpage: 1, cpageSize: newPageSize }));
    };

    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

export default ContentSearchResultsListPagination;
